export class InfoBlock {
	constructor(game) {
		this.game = game;
		this.block = document.getElementById('info-block');
		this.content = this.block.querySelectorAll('.info-block__content');
		this.contentNames = this.block.querySelectorAll('.info-block__content h3');
		this.activeIndex = 0;
		this.isHide = true;
		this.btn = this.block.querySelector('.info-block__continue');
		this.delay = 300;

		this.btn.addEventListener('click', this.close.bind(this));
	}

	open() {
		if (this.activeIndex < this.content.length) {
			this.content[this.activeIndex].style.display = 'block';

			// analytics
			// eslint-disable-next-line no-undef
			gtag('event', 'popup_show', {
				event_label: this.contentNames[this.activeIndex].textContent,
			});

			this.activeIndex++;
			this.isHide = false;

			this.block.classList.add('is-vision');
		}
	}

	close() {
		this.block.classList.remove('is-vision');

		setTimeout(() => {
			this.content[this.activeIndex - 1].style.display = 'none';
			this.isHide = true;
			this.game.play();
		}, this.delay);
	}

	reset() {
		this.activeIndex = 0;
	}
}
